import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import axios from "axios";
import { url as API } from "../../../Redux/actions/URL";

import DashboardOutlinedIcon       from "@mui/icons-material/DashboardOutlined";
import EventNoteOutlinedIcon        from "@mui/icons-material/EventNoteOutlined";
import EventAvailableOutlinedIcon   from "@mui/icons-material/EventAvailableOutlined";
import EditOutlinedIcon             from "@mui/icons-material/EditOutlined";
import GroupsOutlinedIcon           from "@mui/icons-material/GroupsOutlined";

import DrawerListItem   from "../Components/DrawerListItem";
import SectionLabel     from "../Components/SectionLabel";
import GlobalDrawerItems from "./GlobalDrawerItems";

const OrgAdminDrawer = () => {
  const token   = useSelector((state) => state.userInfo.token);
  const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

  const { data: myOrgData } = useQuery(
    "myOrg",
    async () => {
      const { data } = await axios.get(`${API}/orgs/myorg`, { headers });
      return data;
    },
    { enabled: !!token, staleTime: 2 * 60 * 1000 },
  );

  const id = myOrgData?.uuid;

  return (
    <>
      <SectionLabel>Overview</SectionLabel>
      <DrawerListItem
        name="Dashboard"
        path="OrgAdminDashboard"
        Icon={DashboardOutlinedIcon}
        exact
      />

      <SectionLabel>Discover</SectionLabel>
      <GlobalDrawerItems />

      <SectionLabel>Organisation</SectionLabel>
      <DrawerListItem
        name="Edit Profile"
        path="myorg"
        Icon={EditOutlinedIcon}
        exact
      />
      <DrawerListItem
        name="Team"
        path="OrgAdmin/team"
        Icon={GroupsOutlinedIcon}
        exact
      />

      <SectionLabel>Events</SectionLabel>
      <DrawerListItem
        name="Manage"
        path={id ? `myEvents/${id}` : "OrgAdminDashboard"}
        Icon={EventNoteOutlinedIcon}
        exact
      />
      <DrawerListItem
        name="Create"
        path={id ? `CreateEvent/${id}` : "OrgAdminDashboard"}
        Icon={EventAvailableOutlinedIcon}
        exact
      />
    </>
  );
};

export default OrgAdminDrawer;
